import { Page, PageDTO } from '@/shared/api/pagination';
import { messageError } from '@/shared/ui/notifications';
import { InfiniteData } from '@tanstack/react-query-latest';
import { useMemo } from 'react';
import { z } from 'zod/v4';

export const useInfinitePaginationData = <T extends Record<string, any>>(
  data: InfiniteData<Page<T>>,
  transformItem?: (item: T, index: number) => any,
): T[] => {
  return useMemo(() => {
    if (!data?.pages?.length) return [];

    const firstPageValidation = PageDTO.safeParse(data.pages[0]);
    if (!firstPageValidation.success) {
      console.warn('Invalid first page structure:', firstPageValidation.error);
      messageError(z.prettifyError(firstPageValidation.error));
      return [];
    }

    const allItems = data.pages.reduce<T[]>((acc, page) => {
      acc.push(...page.items);
      return acc;
    }, []);

    return allItems.map((item, index) =>
      transformItem ? transformItem(item, index) : { ...item, index },
    );
  }, [data, transformItem]);
};